import ScrollItem from './ScrollItem';
import './FollowUs.css';
import FollowUsSpWebp from '../img/Follow-us-sp.webp';
import FollowUsSp from '../img/Follow-us-sp.png';
import FollowUsPcWebp from '../img/Follow-us-pc.webp';
import FollowUsPc from '../img/Follow-us-pc.png';

export default function FollowUs() {
    return (
        <div className="FollowUs">
            <ScrollItem>
                <a href="https://twitter.com/BosoTokyo" target="_blank">
                    <div className="glitchPatternInfinite03">
                        <picture className="FollowUs--sp">
                            <source type="image/webp" srcSet={FollowUsSpWebp} />
                            <img src={FollowUsSp} alt="Follow us on twitter" />
                        </picture>
                    </div>
                    <div className="glitchPatternInfinite03">
                        <picture className="FollowUs--pc">
                            <source type="image/webp" srcSet={FollowUsPcWebp} />
                            <img src={FollowUsPc} alt="Follow us on twitter" />
                        </picture>
                    </div>
                </a>
            </ScrollItem>
        </div>
    )
}